import { msalInstance } from './auth.service';

interface User {
  email: string;
}

export function loggedIn(): boolean {
  return true;
}

export function logout(): void {
  msalInstance.logoutRedirect();
}

export function getUser(): User | null {
  try {
    const account = msalInstance.getAllAccounts()[0];
    const claims = (account.idTokenClaims || {}) as any;
    return {
      email:
        account.username ||
        claims['preferred_username'] ||
        claims['email'] ||
        claims['emails']?.[0] ||
        claims['signInNames.emailAddress'],
    };
  } catch (error) {
    console.error('getUser() error', error);
    return null;
  }
}

export default {
  loggedIn,
  logout,
  getUser,
};
